import React from "react";
import Image from "next/image";
import {
  PROCESS_ICON1,
  PROCESS_ICON2,
  PROCESS_ICON3,
  RIGHT_ARROW,
} from "@/cdn";
import "./index.scss";
import { appendUrlParams } from "@/utils/url";
import LinkingProcessSkeleton from "./skeleton";
import { ROUTE_MAP } from "@/shared";

const classPrefix = "yfm-product-detail-linking-process";

interface LinkingProcessProps {
  isSkeleton: boolean;
  id: string;
  hashId: string;
}

const LinkingProcess: React.FC<LinkingProcessProps> = (props) => {
  const { isSkeleton, id, hashId } = props;
  const toTutorial = () => {
    appendUrlParams(`${ROUTE_MAP.doc.tutorial}?from=${hashId}`);
  };

  if (isSkeleton) return <LinkingProcessSkeleton />;

  return (
    <div className={classPrefix}>
      <div className={`${classPrefix}__title-box`}>
        <div id={id}>Linking Process</div>
        <div className={`${classPrefix}__title-right`} onClick={toTutorial}>
          <div>Tutorial with images</div>
          <div className={`${classPrefix}__circle-arrow`}>
            <Image width={5} height={9} src={RIGHT_ARROW} alt="" />
          </div>
        </div>
      </div>
      <div className={`${classPrefix}__content-box`}>
        <div className={`${classPrefix}__content-item`}>
          <div className={`${classPrefix}__img-box ${classPrefix}__img-box1`}>
            <Image width={0} height={0} src={PROCESS_ICON1} alt="" />
          </div>
          <div>
            <p>Add</p>
            <p>showcase</p>
          </div>
        </div>
        <Image width={5} height={9} src={RIGHT_ARROW} alt="" />
        <div className={`${classPrefix}__content-item`}>
          <div className={`${classPrefix}__img-box ${classPrefix}__img-box2`}>
            <Image width={0} height={0} src={PROCESS_ICON2} alt="" />
          </div>
          <div>
            <p>Link</p>
            <p>video/live</p>
          </div>
        </div>
        <Image width={5} height={9} src={RIGHT_ARROW} alt="" />
        <div className={`${classPrefix}__content-item`}>
          <div className={`${classPrefix}__img-box ${classPrefix}__img-box3`}>
            <Image width={0} height={0} src={PROCESS_ICON3} alt="" />
          </div>
          <div>
            <p>Earn</p>
            <p>commission</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkingProcess;
